import React from 'react';
import styled from 'styled-components';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { iRootDispatch, iRootState } from '../../store';
import { FaSignOutAlt, FaShieldAlt } from 'react-icons/fa';
import logorv from '../../resources/imgs/logo-lado-bom-seguros-white.svg'; // Assuming a white logo exists or we might need to filter the existing one if it's black
// Note: Using existing logo import from other files for now, adapted via style if SVG.
// The design shows white logo on purple header.
import logoOriginal from '../../resources/imgs/logo-lado-bom-seguros.svg';
import { cleanUserSession } from '../../services/auth';

const Container = styled.div`
  min-height: 100vh;
  background-color: #FFFFFF;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const Header = styled.div`
  width: 100%;
  height: 64px;
  background-color: #FFFFFF;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
`;

const HeaderLogo = styled.img`
  height: 32px;
`;

const LogoutContext = styled.div`
  color: #AAADB1; /* Grey from Figma */
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  cursor: pointer;
  
  svg {
    fill: #AAADB1;
  }
`;

const Content = styled.div`
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
`;

const Title = styled.h2`
  font-weight: 600;
  font-size: 20px;
  line-height: 27px;
  color: #A3A3A3;
  margin: 0;
`;

const Card = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px;
  gap: 14px;
  width: 100%;
  border: 1px solid #C8ACFD;
  border-radius: 6px;
  cursor: pointer;
  transition: transform 0.1s;
  
  &:active {
    transform: scale(0.98);
  }
`;

const CardHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

const IconWrapper = styled.div`
  color: #59249B;
  font-size: 24px;
  display: flex;
  align-items: center;
`;

const CardTitle = styled.span`
  font-style: normal;
  font-weight: 700;
  font-size: 26px;
  line-height: 35px;
  color: #393939;
`;

const CardDescription = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #6B6F77;
  margin: 0;
`;

const FooterAlert = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 20px;
  gap: 10px;
  margin-top: auto; 
  background: rgba(200, 172, 253, 0.2);
  border-radius: 6px;
`;

const AlertText = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #59249B;
  text-align: center;
  margin: 0;
`;

const mapDispatch = (dispatch: iRootDispatch) => ({
});

type Props = ReturnType<typeof mapDispatch> & RouteComponentProps;

const PwaHome = ({ history }: Props) => {

  const handleLogout = () => {
    cleanUserSession();
    history.push('/pwa/login');
  };

  const handleBondInsuranceClick = () => {
    history.push('/pwa/bond-insurance-analysis');
  };

  return (
    <Container>
      <Header>
        <HeaderLogo src={logoOriginal} alt="Lado Bom Seguros" />
        <LogoutContext onClick={handleLogout}>
          <FaSignOutAlt size={22} />
        </LogoutContext>
      </Header>

      <Content>
        <Title>Análise rápida</Title>

        <Card onClick={handleBondInsuranceClick}>
          <CardHeader>
            <IconWrapper>
              <FaShieldAlt />
            </IconWrapper>
            <CardTitle>Seguro fiança</CardTitle>
          </CardHeader>
          <CardDescription>
            Faça uma análise de Seguro Fiança rapidamente! Após a pré-análise, complete a cotação com os dados restantes para contratar pelo painel.
          </CardDescription>
        </Card>

        <Card onClick={() => history.push('/pwa/pre-analyses')}>
          <CardHeader>
            <IconWrapper>
              <FaShieldAlt />
            </IconWrapper>
            <CardTitle>Minhas Pré-Análises</CardTitle>
          </CardHeader>
          <CardDescription>
            Veja o histórico das suas pré-análises de seguro fiança e continue onde parou.
          </CardDescription>
        </Card>

        <FooterAlert>
          <AlertText>
            Apenas algumas funcionalidades estão disponíveis na versão mobile do app Lado Bom. Para maiores detalhes, acesse sua conta pelo nosso painel!
          </AlertText>
        </FooterAlert>
      </Content>
    </Container>
  );
};

export default connect(null, mapDispatch)(PwaHome);
